import React from 'react';
import PropTypes from 'prop-types';
import oneAppModuleWrapper from '@americanexpress/one-app/module-wrapper';
import { IntlProvider } from 'react-intl';
import { addLogToReport, loadLanguagePack, updateLocale } from '@americanexpress/one-app/ducks';
// import { RenderModule, composeModules } from 'holocron';
import { ProgressCircular } from '@americanexpress/dls-react';
import { useSelector } from 'react-redux';
import childRoutes from './childRoutes';
// import ErrorBoundary from './common/ErrorBoundary';
import combineReducers from './redux/ducks';
import { getLocaleFromCountry } from './utils/ModuleMap';
import { getIsLoading } from './redux/selectors';
// import { getIDAASToken } from './services';
import { SET_APPLICATION_TOKEN, SET_IDAAS_FAILURE, SET_IS_LOADING } from './redux/types';
// import { generateHmacSignature } from './utils/hmac';
import { generateHMAC } from './utils';
import envConfig from './envConfig';
const AxpDigitalIdentityUnsubscribe = ({
  languageData,
  locale,
  // location,
  children,
  moduleLoadStatus
}) => {
  const isLoading = useSelector(getIsLoading);
  if (Object.entries(languageData).length === 0 && moduleLoadStatus === 'loading' && isLoading) {
    return /*#__PURE__*/React.createElement(ProgressCircular, null);
  }
  return /*#__PURE__*/React.createElement(IntlProvider, {
    locale: locale,
    messages: languageData
  }, /*#__PURE__*/React.createElement("link", {
    rel: "stylesheet",
    href: "https://www.aexp-static.com/cdaas/dls/packages/@americanexpress/dls/7.15.0/stylesheets/dls-core.min.css"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "icon",
    type: "image/png",
    href: "https://www.americanexpress.com/favicon.ico"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1.0",
    charSet: "utf-8"
  }), /*#__PURE__*/React.createElement("title", null, "Unsubscribe"), children);
};
export const TestableAxpDigitalIdentityUnsubscribe = AxpDigitalIdentityUnsubscribe;
// Read about childRoutes:
// https://github.com/americanexpress/one-app/blob/main/docs/api/modules/Routing.md#childroutes
AxpDigitalIdentityUnsubscribe.childRoutes = childRoutes;

// Read about appConfig:
// https://github.com/americanexpress/one-app/blob/main/docs/api/modules/App-Configuration.md
/* istanbul ignore next */
if (!global.BROWSER) {
  // eslint-disable-next-line n/global-require -- require needs to be inside browser check
  AxpDigitalIdentityUnsubscribe.appConfig = require('./appConfig').default;
}
const dispatchDebugLog = (dispatch, {
  level = 'info',
  eventName,
  payload
}) => dispatch(addLogToReport(level, eventName, payload));
const maskValueForLog = value => {
  if (!value || typeof value !== 'string') {
    return null;
  }
  return `***${value.slice(-4)}`;
};

// const getErrorDetails = (error) => {
//   if (!error) {
//     return {
//       errorText: null,
//       errorMessage: null,
//       errorName: null,
//       errorCode: null,
//       errorCauseMessage: null,
//     };
//   }

//   if (typeof error === 'string') {
//     return {
//       errorText: error,
//       errorMessage: error,
//       errorName: null,
//       errorCode: null,
//       errorCauseMessage: null,
//     };
//   }

//   return {
//     errorText: String(error),
//     errorMessage: error.message || null,
//     errorName: error.name || null,
//     errorCode: error.code || error?.cause?.code || null,
//     errorCauseMessage: error?.cause?.message || null,
//   };
// };

// const requestAndStoreToken = async ({ dispatch }) => {
//   const env = (process.env.ONE_CONFIG_ENV || 'e0').toLowerCase();
//   const tokenUrl = envConfig[env]?.EPCC_TOKEN_URL;
//   const appId = process.env.EPCC_APPID;
//   const secret = process.env.EPCC_SECRET;

//   if (!tokenUrl || !appId || !secret) {
//     dispatchDebugLog(dispatch, {
//       level: 'warn',
//       eventName: 'lmd_token_prereq_missing',
//       payload: {
//         hasTokenUrl: Boolean(tokenUrl),
//         hasAppId: Boolean(appId),
//         hasSecret: Boolean(secret),
//       },
//     });
//     console.warn('Token request skipped: prerequisites missing.');
//     return;
//   }

//   const { signature, timestamp } = await generateHmacSignature(appId, secret);
//   await dispatchDebugLog(dispatch, {
//     eventName: 'lmd_token_signature_generated',
//     payload: {
//       timestamp,
//     },
//   });

//   const tokenPayload = {
//     scope: ['/privacy/preferences/search::post', '/privacy/preferences::post'],
//   };

//   await dispatchDebugLog(dispatch, {
//     eventName: 'lmd_token_request_started',
//     payload: {
//       tokenUrl,
//       scopeCount: tokenPayload.scope.length,
//     },
//   });

//   const response = await dispatch(oneFetchye(tokenUrl, {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       'X-Auth-AppID': appId,
//       'X-Auth-Signature': signature,
//       'X-Auth-Version': '2',
//       'X-Auth-Timestamp': timestamp,
//       Accept: 'application/json',
//     },
//     body: JSON.stringify(tokenPayload),
//   }));

//   await dispatchDebugLog(dispatch, {
//     eventName: 'lmd_token_response_received',
//     payload: {
//       status: response?.data?.status || null,
//       ok: Boolean(response?.data?.ok),
//       hasData: Boolean(response?.data),
//       hasError: Boolean(response?.error),
//     },
//   });

//   if (!response?.data?.ok) {
//     const fallbackError = response?.data?.body?.error
//       || response?.data?.body?.message
//       || response?.data?.body;
//     const errorDetails = getErrorDetails(response?.error || fallbackError);

//     await dispatchDebugLog(dispatch, {
//       level: 'warn',
//       eventName: 'lmd_token_response_not_ok',
//       payload: {
//         status: response?.data?.status || null,
//         ok: Boolean(response?.data?.ok),
//         responseBody: response?.data?.body || null,
//         errorText: errorDetails.errorText,
//         errorMessage: errorDetails.errorMessage,
//         errorName: errorDetails.errorName,
//         errorCode: errorDetails.errorCode,
//         errorCauseMessage: errorDetails.errorCauseMessage,
//         hasTopLevelError: Boolean(response?.error),
//         responseBodyType: response?.data?.body === null ? 'null' : typeof response?.data?.body,
//       },
//     });
//     console.warn(`Token request failed with status ${response?.data?.status || 'unknown'}.`);
//     return;
//   }

//   const tokenResponse = response?.data?.body;
//   await dispatchDebugLog(dispatch, {
//     eventName: 'lmd_token_response_parsed',
//     payload: {
//       hasAuthorizationToken: Boolean(tokenResponse?.authorization_token),
//       expiresIn: tokenResponse?.expires_in || null,
//     },
//   });

//   await dispatch(setApplicationToken({
//     authorizationToken: tokenResponse?.authorization_token,
//     expiresIn: tokenResponse?.expires_in || null,
//     fetchedAt: Date.now(),
//   }));

//   const fetchedToken = tokenResponse?.authorization_token || null;
//   const allowFullTokenLog = process.env.LOG_FULL_TOKEN === 'true';

//   await dispatchDebugLog(dispatch, {
//     eventName: 'lmd_token_saved_to_store',
//     payload: {
//       hasAuthorizationToken: Boolean(fetchedToken),
//       tokenPreview: maskTokenForLog(fetchedToken),
//       token: allowFullTokenLog ? fetchedToken : undefined,
//     },
//   });
// };

export const loadModuleData = async ({
  store,
  fetchClient,
  ownProps = {}
}) => {
  var _envConfig$env;
  if (global.BROWSER) return;
  const {
    dispatch
  } = store;
  const {
    location = {}
  } = ownProps;
  const contextCountry = (location.pathname || '').split('/')[2];
  const mappedLocale = getLocaleFromCountry(contextCountry);
  const env = (process.env.ONE_CONFIG_ENV || 'e0').toLowerCase();
  const idaasApi = (_envConfig$env = envConfig[env]) === null || _envConfig$env === void 0 ? void 0 : _envConfig$env.EPCC_TOKEN_URL;

  // await dispatchDebugLog(dispatch, {
  //   eventName: 'lmd_environment',
  //   payload: {
  //     env,
  //     apiUrl: idaasApi,
  //     hasClientId: Boolean(process.env.EPCC_APPID),
  //     hasSecret: Boolean(process.env.EPCC_SECRET),
  //     clientIdLast4: maskValueForLog(process.env.EPCC_APPID),
  //     secretLast4: maskValueForLog(process.env.EPCC_SECRET),
  //   },
  // });

  await dispatch(updateLocale(mappedLocale));
  await dispatchDebugLog(dispatch, {
    eventName: 'lmd_start1',
    payload: {}
  });
  await dispatchDebugLog(dispatch, {
    eventName: `lmd_start1-1 | idaasApi: ${idaasApi}`,
    payload: {}
  });
  await dispatchDebugLog(dispatch, {
    eventName: `lmd_start1-2 | env: ${env}`,
    payload: {}
  });
  await dispatchDebugLog(dispatch, {
    eventName: `lmd_start1-3 | clientIdLast4: ${maskValueForLog(process.env.EPCC_APPID)}`,
    payload: {}
  });
  await dispatchDebugLog(dispatch, {
    eventName: `lmd_start1-4 | secretLast4: ${maskValueForLog(process.env.EPCC_SECRET)}`,
    payload: {}
  });
  await dispatch(loadLanguagePack('axp-digital-identity-unsubscribe', {
    fallbackLocale: mappedLocale
  }));
  await dispatchDebugLog(dispatch, {
    eventName: 'lmd_start2',
    payload: {}
  });

  // const state = store.getState();
  let idaasToken = '';
  // const cardToken = '';
  await dispatchDebugLog(dispatch, {
    eventName: 'lmd_start3',
    payload: {}
  });
  async function parseErrorResponse(response) {
    const text = await response.text();
    if (!text) return String(response);
    try {
      const parsed = JSON.parse(text);
      return JSON.stringify(parsed);
    } catch {
      return text;
    }
  }

  // async function getCardToken(CARD_API, {
  //   CARD_APP_ID,
  //   CARD_SECRET,
  // }) {
  //   const VERSION = 2;
  //   const timestamp = Date.now().toString();
  //   // await dispatchDebugLog(dispatch, {
  //   //   eventName: 'lmd_start8',
  //   //   payload: {},
  //   // });
  //   const message = `${CARD_APP_ID}-${VERSION}-${timestamp}`;

  //   return generateHMAC(message, CARD_SECRET).then(async (mac) => {
  //     // await dispatchDebugLog(dispatch, {
  //     //   eventName: `lmd_start9 : ${mac}`,
  //     //   payload: {},
  //     // });
  //     try {
  //       const response = await fetchClient(CARD_API, {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //           'X-Auth-AppID': CARD_APP_ID,
  //           'X-Auth-Signature': mac,
  //           'X-Auth-Version': VERSION,
  //           'X-Auth-Timestamp': timestamp,
  //         },
  //         body: JSON.stringify({
  //           scope: ['*'],
  //         }),
  //       });
  //       // await dispatchDebugLog(dispatch, {
  //       //   eventName: 'lmd_start10',
  //       //   payload: {},
  //       // });

  //       if (!response.ok) {
  //         throw await parseErrorResponse(response);
  //       }

  //       return response.json();
  //     } catch (error) {
  //       // await dispatchDebugLog(dispatch, {
  //       //   eventName: 'lmd_start9999 :',
  //       //   payload: {},
  //       // });
  //       console.error('Failed to get IDAAS token:', error);
  //       throw error;
  //     }
  //   });
  // }
  async function getIDAASToken(IDAAS_API, {
    IDAAS_CLIENT_ID,
    IDAAS_SECRET
  }) {
    const VERSION = 2;
    const timestamp = Date.now().toString();
    await dispatchDebugLog(dispatch, {
      eventName: 'lmd_idaas_request_started',
      payload: {
        apiUrl: IDAAS_API,
        hasClientId: Boolean(IDAAS_CLIENT_ID),
        hasSecret: Boolean(IDAAS_SECRET),
        clientIdLast4: maskValueForLog(IDAAS_CLIENT_ID),
        secretLast4: maskValueForLog(IDAAS_SECRET),
        timestamp
      }
    });
    const message = `${IDAAS_CLIENT_ID}-${VERSION}-${timestamp}`;
    return generateHMAC(message, IDAAS_SECRET).then(async mac => {
      try {
        const response = await fetchClient(IDAAS_API, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Auth-AppID': IDAAS_CLIENT_ID,
            'X-Auth-Signature': mac,
            'X-Auth-Version': VERSION,
            'X-Auth-Timestamp': timestamp
          },
          body: JSON.stringify({
            scope: ['/privacy/preferences/search::post', '/privacy/preferences::post']
          })
        });
        await dispatchDebugLog(dispatch, {
          eventName: 'lmd_idaas_response_received',
          payload: {
            ok: response.ok,
            status: response.status,
            statusText: response.statusText
          }
        });
        if (!response.ok) {
          throw await parseErrorResponse(response);
        }
        return response.json();
      } catch (error) {
        await dispatchDebugLog(dispatch, {
          level: 'error',
          eventName: 'lmd_idaas_request_failed',
          payload: {
            errorName: (error === null || error === void 0 ? void 0 : error.name) || null,
            errorMessage: (error === null || error === void 0 ? void 0 : error.message) || String(error)
          }
        });
        throw error;
      }
    });
  }
  dispatch({
    type: SET_IS_LOADING,
    payload: true
  });
  await dispatchDebugLog(dispatch, {
    eventName: 'lmd_start4',
    payload: {}
  });
  function serializeError(error) {
    if (!error) return {};
    if (typeof error === 'string') return {
      message: error
    };
    return {
      message: JSON.stringify(error),
      stack: error.stack,
      name: error.name,
      ...(error.code && {
        code: error.code
      })
    };
  }
  await dispatchDebugLog(dispatch, {
    eventName: 'lmd_start5',
    payload: {}
  });
  try {
    const IDAAS_API = idaasApi;
    const IDAAS_CLIENT_ID = process.env.EPCC_APPID;
    const IDAAS_SECRET = process.env.EPCC_SECRET;

    // const CARD_APP_ID = 'ca3a0994-f5aa-3d5b-a54c-f0d5cefaf82f';
    // const CARD_SECRET = '';
    // const CARD_API_TOKEN = envConfig[env]?.CARD_API_TOKEN;

    await dispatchDebugLog(dispatch, {
      eventName: `lmd_idaas_configuration : ${env} : ${IDAAS_API}`,
      payload: {
        apiUrl: IDAAS_API,
        hasClientId: Boolean(IDAAS_CLIENT_ID),
        hasSecret: Boolean(IDAAS_SECRET)
      }
    });

    // const IDAAS_API = state.getIn(['config', 'IDAAS_API'], '');
    // const IDAAS_CLIENT_ID = state.getIn(['config', 'IDAAS_CLIENT_ID'], '');
    // const IDAAS_SECRET = state.getIn(['config', 'IDAAS_SECRET'], '');
    await dispatchDebugLog(dispatch, {
      eventName: 'lmd_start6',
      payload: {}
    });
    const idaasResponse = await getIDAASToken(IDAAS_API, {
      IDAAS_CLIENT_ID,
      IDAAS_SECRET,
      fetchClient
    });
    // const cardTokenResponse = await getCardToken(CARD_API_TOKEN, {
    //   CARD_APP_ID,
    //   CARD_SECRET,
    //   fetchClient,
    // });
    await dispatchDebugLog(dispatch, {
      eventName: 'lmd_start7',
      payload: {}
    });
    idaasToken = idaasResponse.authorization_token;
    // cardToken = cardTokenResponse.authorization_token;
    dispatch({
      type: SET_APPLICATION_TOKEN,
      payload: idaasToken
    });
    // dispatch({
    //   type: SET_CARD_TOKEN,
    //   payload: cardToken,
    // });
    // await dispatchDebugLog(dispatch, {
    //   level: 'info',
    //   eventName: `card_token_fetched ${cardToken}`,
    //   payload: {
    //     hasIdaasToken: idaasToken,
    //   },
    // });
    await dispatchDebugLog(dispatch, {
      level: 'info',
      eventName: 'token_fetched',
      payload: {
        hasIdaasToken: idaasToken
      }
    });
  } catch (error) {
    dispatch({
      type: SET_IDAAS_FAILURE,
      payload: {
        type: 'idaas',
        info: serializeError(error)
      }
    });
    dispatch({
      type: SET_IS_LOADING,
      payload: false
    });
    return;
  }
  if (!idaasToken) {
    // dispatchDebugLog(dispatch, {
    //   level: 'warn',
    //   eventName: 'lmd_idaas_token_missing',
    //   payload: {
    //     hasIdaasToken: Boolean(idaasToken),
    //   },
    // });
  } else {
    dispatchDebugLog(dispatch, {
      eventName: 'lmd_idaas_token_fetched',
      payload: {
        hasIdaasToken: Boolean(idaasToken),
        tokenLast4: maskValueForLog(idaasToken)
      }
    });
  }
  dispatch({
    type: SET_IS_LOADING,
    payload: false
  });
};

// export const loadModuleData = async ({
//   store,
//   ownProps = {},
// }) => {
//   const { dispatch } = store;
//   const { location = {} } = ownProps;
//   const contextCountry = (location.pathname || '').split('/')[2];
//   const mappedLocale = getLocaleFromCountry(contextCountry);
//   await dispatchDebugLog(dispatch, {
//     eventName: 'lmd_start',
//     payload: {
//       path: location.pathname || null,
//       contextCountry,
//       mappedLocale,
//       env: process.env.ONE_CONFIG_ENV || 'local',
//     },
//   });

//   await dispatch(updateLocale(mappedLocale));

//   await dispatchDebugLog(dispatch, {
//     eventName: 'lmd_locale_updated',
//     payload: {
//       mappedLocale,
//     },
//   });

//   await dispatch(
//     loadLanguagePack('axp-digital-identity-unsubscribe', {
//       fallbackLocale: mappedLocale,
//     })
//   );

//   await dispatchDebugLog(dispatch, {
//     eventName: 'lmd_language_pack_loaded',
//     payload: {
//       moduleName: 'axp-digital-identity-unsubscribe',
//       fallbackLocale: mappedLocale,
//     },
//   });

//   // if (global.BROWSER) {
//   //   await dispatchDebugLog(dispatch, {
//   //     eventName: 'lmd_browser_skip_token_request',
//   //     payload: {
//   //       reason: 'browser runtime',
//   //     },
//   //   });
//   //   return;
//   // }

//   await requestAndStoreToken({ dispatch });

//   //! enable it when we have the global header and footer modules are migrated to holocron v7
//   // await dispatch(composeModules([{ name: 'axp-global-header' }, { name: 'axp-footer' }]));
// };

AxpDigitalIdentityUnsubscribe.holocron = {
  name: 'axp-digital-identity-unsubscribe',
  loadModuleData,
  reducer: combineReducers
};
export default oneAppModuleWrapper('axp-digital-identity-unsubscribe')(AxpDigitalIdentityUnsubscribe);